import { render, staticRenderFns } from "./PrivacySlothysBakery.vue?vue&type=template&id=15e726fe&scoped=true"
import script from "./PrivacySlothysBakery.vue?vue&type=script&lang=js"
export * from "./PrivacySlothysBakery.vue?vue&type=script&lang=js"
import style0 from "./PrivacySlothysBakery.vue?vue&type=style&index=0&id=15e726fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e726fe",
  null
  
)

export default component.exports